import React, {useState} from "react";
import classnames from 'classnames'
import {useDealContext} from "../../contexts/DealContext";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Tooltip from "@mui/material/Tooltip";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import {DealRebateModal} from "./DealRebateModal";
import CurrencyInput from "react-currency-input-field";
import Checkbox from "@mui/material/Checkbox";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useMediaQuery} from "react-responsive";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import useRebateStateHook from "../../hooks/useRebateStateHook";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

import Stack from "@mui/material/Stack";

export const DealPageRebateItem = ({
   rebate,
}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [rebateState, setRebateStateWithUpdate] = useRebateStateHook(rebate)
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const {updateDealResponse} = useDealContext()
    const [isRebateModalOpen, setIsRebateModalOpen] = useState(false)

    const isLoading = updateDealResponse?.loading
    const isStackable = rebateState.is_compatible
    const isCustom = rebateState.is_custom

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <TableRow>
            <TableCell
                align="left"
                width={isTabletOrMobile ? '1%' : '20%'}
            >
                <span
                    style={{
                        color: '#666666',
                    }}
                >
                    {rebate.name}
                </span>
                {
                    !isTabletOrMobile && !isCustom &&
                    <Tooltip title="Details" arrow placement={'top'}>
                        <DescriptionOutlinedIcon
                            className={'DescriptionIcon'}
                            onClick={() => setIsRebateModalOpen(!isRebateModalOpen)}
                        />
                    </Tooltip>
                }
                {
                    isRebateModalOpen &&
                    <DealRebateModal
                        rebate={rebate}
                        isOpen={isRebateModalOpen}
                        setIsOpen={setIsRebateModalOpen}
                        name={rebateState.name}
                        description={rebateState.description}
                        expirationDate={rebateState.expiration_date}
                    />
                }
            </TableCell>
            <TableCell
                align="right"
                width={isTabletOrMobile ? '50%' : '20%'}
            >
                <div
                    style={{
                        display: isTabletOrMobile ? 'flex' : '',
                        flexDirection: isTabletOrMobile ? "row" : '',
                        alignItems: isTabletOrMobile ? 'center' : ''
                    }}
                >
                    {
                        isStackable && !isTabletOrMobile &&
                        <Tooltip title="Stackable" arrow placement={'top'}>
                            <ContentCopyIcon style={{ color: "rgba(0, 0, 0, 0.87)", fontSize: '16px'}}/>
                        </Tooltip>
                    }
                    <CurrencyInput
                        className={'payment-row_value disabled'}
                        prefix="$"
                        value={rebateState.amount}
                        disabled={true}
                        style={{ width: isTabletOrMobile ? '100%' : ''}}
                    />
                    {
                        isTabletOrMobile &&
                        <div

                        >
                            <MoreVertIcon onClick={handleClick}/>
                            <Popover
                                onClick={(e) => e.stopPropagation()}
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top'
                                }}
                            >
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Applied
                                    </Typography>
                                    <Checkbox
                                        className={classnames('payment-row_value', {
                                            isDisabled: isLoading || !rebateState.is_applied,
                                        })}
                                        onChange={() => setRebateStateWithUpdate({...rebateState, is_applied: !rebateState.is_applied}, true)}
                                        checked={rebateState.is_applied}
                                        disabled={isLoading}
                                    />
                                </Stack>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Taxed
                                    </Typography>
                                    <Checkbox
                                        className={classnames('payment-row_value', {
                                            isDisabled: isLoading || !rebateState.is_applied,
                                        })}
                                        onChange={() => setRebateStateWithUpdate({...rebateState, is_taxed: !rebateState.is_taxed}, true)}
                                        checked={rebateState.is_applied && rebateState.is_taxed}
                                        disabled={isLoading || !rebateState.is_applied}
                                    />
                                </Stack>
                            </Popover>
                        </div>
                    }
                </div>
            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        width={isTabletOrMobile ? '5%' : '10%'}
                        align="right"
                    >
                        <Checkbox
                            className={'payment-row_value'}
                            onChange={() => setRebateStateWithUpdate({...rebateState, is_applied: !rebateState.is_applied}, true)}
                            checked={rebateState.is_applied}
                            disabled={isLoading}
                        />
                    </TableCell>
                    <TableCell
                        align="right"
                        width={isTabletOrMobile ? '5%' : '10%'}
                    >
                        <Checkbox
                            className={classnames('payment-row_value', {
                                isDisabled: isLoading || !rebateState.is_applied,
                            })}
                            onChange={() => setRebateStateWithUpdate({...rebateState, is_taxed: !rebateState.is_taxed}, true)}
                            checked={rebateState.is_applied && rebateState.is_taxed}
                            disabled={isLoading || !rebateState.is_applied}
                        />
                    </TableCell>
                </React.Fragment>
            }
        </TableRow>
    )
}